<div class="container">
  <div class="close" *ngIf="!header">
    <!--  <li style="padding-left: 10px;">-->
    <!--    CONTATOS:-->
    <!--  </li>-->
    <th>
      <span (click)="close()" class="material-icons">close</span>
    </th>
  </div>

  <div class="list">
    <div class="item">
      <a href="https://br.linkedin.com/in/marcus-coube" target="_blank">
        <span class="iconify" data-icon="brandico:linkedin-rect"></span>
      </a>
    </div>
    <div class="item">
      <a href="mailto:viinny.ac@gmail.com?subject=Olá Marcus" target="_blank">
        <span class="iconify" data-icon="simple-icons:gmail"></span> </a>
    </div>
    <div class="item">
      <a href="https://api.whatsapp.com/send?phone=+5514996299942" target="_blank">
        <span class="iconify" data-icon="akar-icons:whatsapp-fill"></span>
      </a>
    </div>
    <div class="item">
      <a href="https://gitlab.com/viinnyac" target="_blank">
        <span class="iconify" data-icon="cib:gitlab"></span>
      </a>
    </div>
  </div>
</div>
